import React from 'react';
import { AttentionReportsDashboard } from '@/components/enterprise/AttentionReportsDashboard';

const AttentionReportsPage: React.FC = () => {
  return (
    <div className="container mx-auto py-6">
      <AttentionReportsDashboard />
    </div>
  );
};

export default AttentionReportsPage;
